import React, { useState } from 'react'
import { Alert, Box } from '@mui/material'

import { useApp } from '../../AppContext/AppProvider'

import {
  buildAutocompleteQuery,
  AutoCompleteAddressResult,
  Address
} from '../../../domain/address'
import { extractMessageFromServiceError } from '../../../services/error.service'
import { FormComponentProps } from '../../FormContainer/types'

import AddressForm from './AddressForm.component'
import { PersonalQuestionValues } from './types'

const AddressFormContainer: React.FC<
  FormComponentProps<PersonalQuestionValues>
> = ({ formData, setFormData, setFormError }) => {
  const { application } = useApp()
  const [suggestions, setSuggestions] = useState<AutoCompleteAddressResult[]>(
    []
  )
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const getAddressAutocomplete = ({
    country,
    ...address
  }: Address): Promise<void> => {
    setError(null)
    setIsLoading(true)

    const queryString = buildAutocompleteQuery(address)

    return application
      .service('geo/addresses/similar')
      .find({ query: { $q: queryString } })
      .then(setSuggestions)
      .catch((e: any) => {
        setError(extractMessageFromServiceError(e))
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      <AddressForm
        suggestions={suggestions}
        loading={isLoading}
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        getSuggestions={getAddressAutocomplete}
      />
      {error && (
        <Box sx={{ mt: 2 }}>
          <Alert severity="error">{error || ''}</Alert>
        </Box>
      )}
    </>
  )
}

export default AddressFormContainer
